import { Ingredient } from "@/db/index.server";
import { createUserIngredient } from "@/lib/ingredients/mutations.server";
import type { IngredientWriteValues } from "@/lib/ingredients/serialization.server";
import { requireSessionUser } from "@/lib/serverAuth";
import * as Sentry from "@sentry/cloudflare";
import { createServerFn } from "@tanstack/react-start";

type CreateIngredientParams = IngredientWriteValues;

export const createIngredient = createServerFn({ method: "POST" })
  .inputValidator((data: CreateIngredientParams) => data)
  .handler(async ({ data: ingredient }): Promise<Ingredient> => {
    const user = await requireSessionUser();

    try {
      return (
        await createUserIngredient({ input: ingredient, userId: user.id })
      ).ingredient;
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);
      throw new Error("Something went wrong");
    }
  });
